// @ts-nocheck
/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'
import {SeqId} from './seq-id.js'
import {SetDecoratorStyle} from './set-decorator-style.js'
import {SetFloat} from './set-float.js'
import {SetParagraphAlignment} from './set-paragraph-alignment.js'
import {SetString} from './set-string.js'
import {SetUInt8} from './set-uint8.js'
import {SetWritingDirection} from './set-writing-direction.js'

export class ModifyParagraphStyle {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifyParagraphStyle {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsModifyParagraphStyle(bb: flatbuffers.ByteBuffer, obj?: ModifyParagraphStyle): ModifyParagraphStyle {
    return (obj || new ModifyParagraphStyle()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsModifyParagraphStyle(
    bb: flatbuffers.ByteBuffer,
    obj?: ModifyParagraphStyle
  ): ModifyParagraphStyle {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ModifyParagraphStyle()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  start(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  end(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  indentLevel(obj?: SetUInt8): SetUInt8 | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? (obj || new SetUInt8()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  alignment(obj?: SetParagraphAlignment): SetParagraphAlignment | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset
      ? (obj || new SetParagraphAlignment()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null
  }

  lineSpacing(obj?: SetFloat): SetFloat | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? (obj || new SetFloat()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  decoratorStyle(obj?: SetDecoratorStyle): SetDecoratorStyle | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? (obj || new SetDecoratorStyle()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  isChecked(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 16)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  textField(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 18)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  programmingLanguage(obj?: SetString): SetString | null {
    const offset = this.bb!.__offset(this.bb_pos, 20)
    return offset ? (obj || new SetString()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  writingDirection(obj?: SetWritingDirection): SetWritingDirection | null {
    const offset = this.bb!.__offset(this.bb_pos, 22)
    return offset
      ? (obj || new SetWritingDirection()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null
  }

  static startModifyParagraphStyle(builder: flatbuffers.Builder) {
    builder.startObject(10)
  }

  static addStart(builder: flatbuffers.Builder, startOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, startOffset, 0)
  }

  static addEnd(builder: flatbuffers.Builder, endOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, endOffset, 0)
  }

  static addIndentLevel(builder: flatbuffers.Builder, indentLevelOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, indentLevelOffset, 0)
  }

  static addAlignment(builder: flatbuffers.Builder, alignmentOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, alignmentOffset, 0)
  }

  static addLineSpacing(builder: flatbuffers.Builder, lineSpacingOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, lineSpacingOffset, 0)
  }

  static addDecoratorStyle(builder: flatbuffers.Builder, decoratorStyleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, decoratorStyleOffset, 0)
  }

  static addIsChecked(builder: flatbuffers.Builder, isChecked: boolean) {
    builder.addFieldInt8(6, +isChecked, null)
  }

  static addTextField(builder: flatbuffers.Builder, textFieldOffset: flatbuffers.Offset) {
    builder.addFieldStruct(7, textFieldOffset, 0)
  }

  static addProgrammingLanguage(builder: flatbuffers.Builder, programmingLanguageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, programmingLanguageOffset, 0)
  }

  static addWritingDirection(builder: flatbuffers.Builder, writingDirectionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, writingDirectionOffset, 0)
  }

  static endModifyParagraphStyle(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }
}
